/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getAccountHistory.defs.js'
export { main as default } from './getAccountHistory.defs.js'
